import { awarenessRoutes } from '@features/Awareness/routes/awareness.routes'
import { getMesstellenRoutes } from '@features/Messstellen/routes/messstellen.routes'
import { monthlyReportEmail } from '@features/MonthlyReportEmail/routes/monthlyReportEmail.routes'
import { performanceVsMarketEmail } from '@features/PerformanceVsMarketEmail/routes/performanceVsMarketEmail.routes'
import { dashboardRoutes } from '@features/dashboard/presentation/routes/dashboard.routes'
import { getEnergyCostRoutes } from '@features/energiekosten/energiekosten.routes'
import { energyReportEmail } from '@features/energyReportEmail/routes/energyReportEmail.routes'
import { getIsoSuiteRoutesV2 } from '@features/iso-suite/iso-suite.routes'
import { profileRoutes } from '@features/profile/presentation/profile.routes'
import { sessionRoutes } from '@features/session/presentation/session.routes'
import { smaRoutes } from '@features/sma/routes/sma.routes'
import { type ReactElement, useMemo } from 'react'
import { useRoutes } from 'react-router-dom'
import { procurementDetailRoutes as procurementDetailRoutesV2 } from '../features/procurement-and-markets/details/procurement-details.routes'
import { root } from './root'

import { useLocationModules } from '@/src/hooks/location-module/location-module.hooks'
import { fallbackRoute } from '@/src/routes/fallback.route'
import { getConsultancyRoutes } from '@features/Consultancy/consultancy.routes'
import { getCustomSectionRoutes } from '@features/CustomSection/customSection.routes'
import { getFlexRoutes } from '@features/Flex/flex.routes'
import { getReportsRoutes } from '@features/Reports/reports.routes'
import { analyticsRoutesV2 } from '@features/analytics/analytics.routes'
import { dataManagementRoutes } from '@features/datenmanagement/datenmanagement.routes'
import { helpCenterRoutes } from '@features/help-center/routes/help-center.routes'
import { insightInboxRoutes } from '@features/insight-inbox/insight-inbox.routes'
import { getMeasureHubRoutes } from '@features/measure-hub/measure-hub.routes'
import { procurementAndMarketsRoutes } from '@features/procurement-and-markets/procurement.routes'
import { useIsEasyOfferEnpiEnabled } from '@shared/feature-flag/feature-flag.hooks'

export default function AppRoute(): ReactElement | null {
  const { data: enabledModulesData } = useLocationModules()
  const enabledModules = enabledModulesData?.enabledModules ?? []
  const isEasyOfferEnpiEnabled = useIsEasyOfferEnpiEnabled()

  // Avoid rebuilding the route config (and the JSX it wraps) on every unrelated AppRoute re-render
  // (e.g. useLocationModules refetching) - only recompute when what it's actually built from changes.
  const routes = useMemo(
    () => [
      ...dashboardRoutes,
      ...getMesstellenRoutes(isEasyOfferEnpiEnabled),
      ...awarenessRoutes,
      //...emberRoutes,
      ...sessionRoutes,
      ...profileRoutes,
      ...smaRoutes,
      ...energyReportEmail,
      ...monthlyReportEmail,
      ...performanceVsMarketEmail,
      ...helpCenterRoutes,
      ...getIsoSuiteRoutesV2(enabledModules),
      ...getMeasureHubRoutes(isEasyOfferEnpiEnabled),
      ...procurementAndMarketsRoutes,
      ...procurementDetailRoutesV2,
      ...analyticsRoutesV2,
      ...getEnergyCostRoutes(),
      ...dataManagementRoutes,
      ...getFlexRoutes(),
      ...getReportsRoutes(),
      ...getCustomSectionRoutes(),
      ...getConsultancyRoutes(),
      ...insightInboxRoutes,
    ],
    [isEasyOfferEnpiEnabled, enabledModules]
  )

  return useRoutes([root, ...routes, fallbackRoute])
}
